import { connect } from 'react-redux';

import ListsCreateEditDummyModal from 'modules/lists/components/list-create-edit-modal/ListCreateEditDummyModal';

import { danger, success } from 'redux-store/reducers/common-reducer';
import { createListFromSubcampaigns } from 'modules/subcampaigns/reducers/subcampaign';

import { __t, applyTranslations } from 'utils/language';

import type { ListMeta } from 'types';

applyTranslations(require('./create-collection-modal.i18n.json'));

type OwnProps = {
  campaignId: number,
  offerState: string
};

const mapDispatchToProps = (dispatch, {
  campaignId,
  offerState
}: OwnProps) => ({
  dispatchSaveList: (list: ListMeta, organizationId: number) =>
    dispatch(createListFromSubcampaigns(list, campaignId, organizationId, offerState))
      .then(collectionUrl =>
        collectionUrl && dispatch(success(__t('create_collection_modal.success', { collectionUrl }))))
      .catch(() => dispatch(danger(__t('create_collection_modal.error'))))
});

export default connect(undefined, mapDispatchToProps)(ListsCreateEditDummyModal);
